import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=7cab7f8e&scoped=true"
import script from "./dialog.vue?vue&type=script&lang=ts"
export * from "./dialog.vue?vue&type=script&lang=ts"
import style0 from "./dialog.vue?vue&type=style&index=0&id=7cab7f8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cab7f8e",
  null
  
)

export default component.exports